module.exports = __webpack_public_path__ + "img/6.136877bb.jpg";